import { leaveCentralDePrivacidade } from 'common'
import { useScreenFinishLoadTac } from 'common/hooks/useScreenFinishLoadTac'
import { useLocation } from 'react-router-dom'
import { Routes } from 'common/constants'
import { setFallbackUnknownErrorPageContent } from 'pages/error/utils'

import {
  IGetPrivacyPolicyAcceptanceContentResponse,
  TUsePrivacyPolicyAcceptanceErrorReturn,
} from '../types'

const usePrivacyPolicyAcceptanceError = (): TUsePrivacyPolicyAcceptanceErrorReturn => {
  const location = useLocation()

  const { state } = location

  const receivedContent: IGetPrivacyPolicyAcceptanceContentResponse['content']['errorFeedbackPage'] =
    {
      icon: state?.content?.icon,
      iconColor: state?.content?.iconColor,
      title: state?.content?.title,
      details: state?.content?.details,
      confirmButton: state?.content?.confirmButton,
    }

  const { icon, iconColor, title, details, confirmButton } = receivedContent

  const isContentError = !icon || !title || !details

  const isError = !iconColor || !confirmButton || isContentError

  const content = isError ? setFallbackUnknownErrorPageContent('pt-BR') : receivedContent

  const confirmButtonClickHandler = () => {
    leaveCentralDePrivacidade()
  }

  useScreenFinishLoadTac({
    name: 'PrivacyPolicyAcceptanceError',
    entity: undefined,
    action: 'PrivacyPolicyAcceptanceError',
    screen: Routes.PRIVACY_POLICY_ACCEPTANCE_ERROR,
    shouldSend: true,
    logLabel: 'send privacy policy acceptance error tac',
  })

  return {
    icon: content.icon ?? 'core/status/ic_close_circle_fill',
    iconColor: content.iconColor ?? 'var(--error500)',
    title: content.title,
    details: content.details,
    confirmButtonText: content.confirmButton,
    confirmButtonClickHandler,
  }
}

export { usePrivacyPolicyAcceptanceError }
